module.exports = __webpack_public_path__ + "img/guaranteed-mobile.20f857c9.jpg";